import { WebSurveysService } from './web';

export default WebSurveysService;
